import React from 'react';
import { View, TouchableOpacity, Animated } from 'react-native';

import PropTypes from 'prop-types';

import { useTheme, LightThemeColors } from '@vfgroup-oneplatform/foundation/Components/Themes';

import FrameworkTestKeys from '../../../../FrameworkTestKeys';

import styles from './CollapseIcon.Styles';

function CollapseIcon({ animation, isVisible }) {
  const theme = useTheme() || LightThemeColors;

  return isVisible ? (
    <TouchableOpacity
      style={styles.dashStyle}
      testID={FrameworkTestKeys.CollapseIcon}
      onPressIn={() => {}}
      accessible={false}
    >
      <Animated.View style={animation} testID={FrameworkTestKeys.trayCollapseIconAnimatedView}>
        <View style={styles.button(theme)} testID={FrameworkTestKeys.trayCollapseIconView} />
      </Animated.View>
    </TouchableOpacity>
  ) : null;
}

CollapseIcon.propTypes = {
  animation: PropTypes.object,
  isVisible: PropTypes.bool,
};

export default CollapseIcon;
